import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import logo from '../../img/branding/branding.svg';
import MainNav from '../MainNav';
import Headroom from 'react-headrooms';

class Header extends Component {
  render () {
    return (
      <Headroom
        tolerance={10}
        offset={20}
        classes={{
          // when element is initialised
          initial: 'js-headroom',
          // when scrolling up
          pinned: 'js-headroom--pinned',
          // when scrolling down
          unpinned: 'js-headroom--unpinned',
          // when above offset
          top: 'js-headroom--top',
          // when below offset
          notTop: 'js-headroom--not-top'
        }}
      >
        <header className='site-header'>
          <div className='l-container'>
            <a href='/' className='branding'>
              <img src={logo} alt='BSLcourses logo' />
            </a>
            <MainNav />
          </div>
        </header>
      </Headroom>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js